module.exports = __webpack_public_path__ + "img/examinationroom.be2a5d8b.png";